<!-- 
	ActionEmailVerification
	role: Admin
	Initially display @/components/AdminUserList and push data to @/components/AdminUserData 
-->

<template>
	<div class="admin text-white">
		<div
			v-if="user.apiData !== null && user.additionalData.isStrideAdmin === true"
		>
			<div class="flex flex-row justify-between mb-4">
				<template v-if="skip !== 0"
					><CustomButton @click="previous"
						>Previous</CustomButton
					></template
				>
				<template v-else>
					<CustomButton>Previous</CustomButton>
				</template>
				<CustomButton @click="next">Next</CustomButton>
			</div>
			<div v-if="!loading">
				<AdminUserList v-bind:skip="skip" />
			</div>
			<div v-else>
				<Loading />
			</div>
		</div>
		<div v-else>
			You must be a Stride Administrator to access this page.<br />If you believe
			this is an error please contact support.
		</div>
	</div>
</template>

<script>
	import { computed } from "vue";
	import { mapGetters, useStore } from "vuex";

	import AdminUserList from "@/components/AdminUserList";
	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	import { getAllUsers } from "@/utils/api";
	import store from "../store/index";

	export default {
		name: "Admin",
		components: {
			AdminUserList,
			CustomButton,
			Loading,
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
		data() {
			return {
				skip: 0,
				loading: true,
			};
		},
		setup() {
			const store = useStore();

			return {
				user: computed(() => store.state.user),
			};
		},
		async created() {
			try {
				if (this.user.additionalData.isStrideAdmin === true) {
					// if user is an admin continue
					const token = this.user.token;

					const skip = this.skip;

					const res = await getAllUsers(token, skip);

					if (res.Success) {
						// if success set admin data to vuex
						store.dispatch("setAdminData", res.Data);

						this.loading = false;
					} else {
						// if failure throw modal error
						store.dispatch("setError", res.Exception.Message);
						this.loading = false;
					}
				}
			} catch (err) {
				// else throw modal error
				console.log(err);
				store.dispatch("setError", err);
			}
		},
		methods: {
			async loadUsers() {
				// paginate user list
				try {
					if (this.user.additionalData.isStrideAdmin === true) {
						store.dispatch("dropAdminData");

						const token = this.user.token;

						const skip = this.skip;

						const res = await getAllUsers(token, skip);

						if (res.Success) {
							store.dispatch("setAdminData", res.Data);
							this.loading = false;
						} else {
							store.dispatch("setError", res.Exception.Message);
							this.loading = false;
						}
					}
				} catch (err) {
					// throw modal error on failure
					console.log(err);
					store.dispatch("setError", err);
				}
			},

			next() {
				// load next 500 users
				this.loading = true;
				this.skip += 500;
				this.loadUsers();
			},

			previous() {
				// load previous 500 users
				this.loading = true;
				this.skip -= 500;
				this.loadUsers();
			},
		},
	};
</script>
